import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import MembersDashboard from "@/pages/MembersDashboard";
import Events from "@/pages/Events";
import Forum from "@/pages/Forum";
import Members from "@/pages/Members";
import History from "@/pages/History";
import Docs from "@/pages/Docs";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Partners from "@/pages/Partners";
import InMemory from "@/pages/InMemory";
import Formation from "@/pages/Formation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/o-klubie" element={<About />} />
              <Route path="/galeria" element={<Gallery />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/znajomi" element={<Partners />} />
              <Route path="/in-memory" element={<InMemory />} />
              <Route path="/logowanie" element={<Login />} />

              <Route path="/strefa" element={<ProtectedRoute><MembersDashboard /></ProtectedRoute>} />
              <Route path="/wydarzenia" element={<ProtectedRoute><Events /></ProtectedRoute>} />
              <Route path="/formacja" element={<ProtectedRoute><Formation /></ProtectedRoute>} />
              <Route path="/forum" element={<ProtectedRoute><Forum /></ProtectedRoute>} />
              <Route path="/czlonkowie" element={<ProtectedRoute><Members /></ProtectedRoute>} />
              <Route path="/historia" element={<ProtectedRoute><History /></ProtectedRoute>} />
              <Route path="/regulamin" element={<ProtectedRoute><Docs /></ProtectedRoute>} />
              <Route path="/profil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
